import React, { Component } from 'react';
import { Form, Row, Col } from 'react-bootstrap';

class FdfForm extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const selectedPlayBehavior = this.props.selectedPlayBehavior;
        const goodHandBeh = selectedPlayBehavior.handBehavior[0];
        const badHandBeh = selectedPlayBehavior.handBehavior[2];

        return (
            <div>
                <div className="pt-4 pb-3">
                    <u>Chance of Good Hand Being Played</u>
                </div>
                <Form.Group as={Row} controlId="Model Name">
                    <Form.Label column xs="4">
                        Chance of Playing
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control type="text" readOnly={selectedPlayBehavior.isCommon}
                            value={goodHandBeh.play_freq*100 + "%"}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="Model Name">
                    <Form.Label column xs="4">
                        Starting Hand Rank
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control plaintext value={1} readOnly/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="Model Name">
                    <Form.Label column xs="4">
                        Ending Hand Rank
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control type="text" readOnly={selectedPlayBehavior.isCommon}
                            value={goodHandBeh.end_rank}/>
                    </Col>
                </Form.Group>

                <div className="pt-3 pb-3">
                    <u>Chance of Mediocre Hand Being Played</u>
                </div>
                <p className="text-left">
                    Chance of mediocre hands being played are interpolated from the ending hand
                    rank of "Good Hand" to the starting hand rank of "Bad Hand".
                </p>


                <div className="pt-3 pb-3">
                    <u>Chance of Bad Hand Being Played</u>
                </div>
                <Form.Group as={Row} controlId="Model Name">
                    <Form.Label column xs="4">
                        Chance of Playing
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control type="text" readOnly={selectedPlayBehavior.isCommon}
                            value={badHandBeh.play_freq*100 + "%"}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="Model Name">
                    <Form.Label column xs="4">
                        Starting Hand Rank
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control type="text" readOnly={selectedPlayBehavior.isCommon}
                            value={badHandBeh.start_rank}/>
                    </Col>
                </Form.Group>
                <Form.Group as={Row} controlId="Model Name">
                    <Form.Label column xs="4">
                        Ending Hand Rank
                    </Form.Label>
                    <Col xs="8">
                        <Form.Control plaintext value={169} readOnly/>
                    </Col>
                </Form.Group>

            </div>
        )
    }
}

export default FdfForm;